var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#423DCF",
    clipPath: "url(#info_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.167 1.333h-.734A1.84 1.84 0 0 0 5.667 0C4.827 0 4.12.567 3.9 1.333h-.733c-.274 0-.5.227-.5.5v1c0 .64.526 1.167 1.166 1.167H7.5c.64 0 1.167-.527 1.167-1.167v-1c0-.273-.227-.5-.5-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 2h-.167v.833c0 1.014-.82 1.834-1.833 1.834H3.833A1.83 1.83 0 0 1 2 2.833V2h-.167C.82 2 0 2.82 0 3.833v8.334C0 13.18.82 14 1.833 14h4.394a5.8 5.8 0 0 1-.554-2.333H2.5a.504.504 0 0 1-.5-.5c0-.274.227-.5.5-.5h3.227q.092-.609.293-1.167H2.5A.504.504 0 0 1 2 9c0-.273.227-.5.5-.5h4c.26-.427.567-.82.927-1.167H2.5a.504.504 0 0 1-.5-.5c0-.273.227-.5.5-.5h6.293c.767-.4 1.627-.64 2.54-.66v-1.84C11.333 2.82 10.513 2 9.5 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 7A4.505 4.505 0 0 0 7 11.5c0 2.481 2.019 4.5 4.5 4.5s4.5-2.019 4.5-4.5S13.981 7 11.5 7m.667 6.333a.667.667 0 1 1-1.334 0V11a.667.667 0 1 1 1.334 0zM11.5 10a.667.667 0 1 1 0-1.334.667.667 0 0 1 0 1.334"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "info_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgInfo;